import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { AlloyGatorSection } from '../components/AlloyGatorSection';
import { HighlightSection } from '../components/HighlightSection';
import { PortfolioSection } from '../components/PortfolioSection';
import { USPSection } from '../components/USPSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { CTASection } from '../components/CTASection';
import { SEOTextSection } from '../components/SEOTextSection';
import { SEO } from '../components/SEO';
export const HomePage = () => {
  return <main data-id="element-1538">
      <SEO title="BK Customs Almere | Ramen Blinderen & Auto Wrappen in Almere" description="Premium auto styling in Almere: ramen tinten, car wrapping, lichten smoken en ontchromen. Professionele service met 5-sterren beoordelingen. Maak direct een afspraak!" canonical="/" data-id="element-1539" />
      <HeroSection data-id="element-1540" />
      <ServicesSection data-id="element-1541" />
      <PortfolioSection data-id="element-1542" />
      <ReviewsSection data-id="element-1543" />
      <AlloyGatorSection data-id="element-1544" />
      <HighlightSection data-id="element-1545" />
      <USPSection data-id="element-1546" />
      <SEOTextSection data-id="element-1547" />
      <CTASection data-id="element-1548" />
    </main>;
};